/** Простая проверка формы email (как в анкетах и флоу регистрации). */
export const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isSimpleValidEmail(value: string): boolean {
  return SIMPLE_EMAIL_REGEX.test(value.trim());
}
